import React from "react";
import { CustomFormSegmentReportData } from "../../../../amorg-common";
import { Card } from "../../../../designSystem/Card";
import { ReportFieldHeader } from "../../[parm]/_components/ReportFieldHeader";

type FreeTextReportFieldProps = {
    fieldId:string,
    fieldLabel:string,
    segmentReports:CustomFormSegmentReportData[]
}
export function FreeTextReportField(props:FreeTextReportFieldProps):JSX.Element
{
    const texts:string[] = [];
    for(const segmentReport of props.segmentReports)
    {
        const fieldSelections = segmentReport.dataSelections.find(s => s.fieldId === props.fieldId);
        if(fieldSelections)
        {
            for(const fs of fieldSelections.selection)
            {
                if(fs.value)
                    texts.push(fs.value);
            }
        }
    }

    return (
        <section>
            <ReportFieldHeader>{props.fieldLabel}</ReportFieldHeader>
            <Card variant="outlined">
                {texts.map((s,i) => {
                    return (
                        <div key={props.fieldId + "_" + i} style={{marginTop:5, padding:3, border:'1px solid #ccc', borderRadius:3, wordWrap:'break-word'}}>{s}</div>
                    );
                })}

                {texts.length === 0 && <div style={{marginTop:5}}>Ingen værdier oprettet</div>}
            </Card>
        </section>
    );
}